import script from "./GlobalPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalPolicy.vue?vue&type=script&setup=true&lang=js"

import "./GlobalPolicy.vue?vue&type=style&index=0&id=9bb55ac2&lang=css"

const __exports__ = script;

export default __exports__